// src/api/minihome.js
import api from "./axios";

const u = (username) => encodeURIComponent(username);

// --- 내 미니홈 ---
export const getMyMinihome = () => api.get("/api/minihome/my/");
export const patchMyMinihome = (payload) => api.patch("/api/minihome/my/", payload);

// --- 공개 미니홈 ---
export const getUserMinihome = (username) =>
    api.get(`/api/minihome/${u(username)}/`);

// --- 방명록 ---
export const getGuestbook = (username) =>
    api.get(`/api/minihome/${u(username)}/guestbook/`);
export const postGuestbook = (username, data) =>
    api.post(`/api/minihome/${u(username)}/guestbook/`, data);
export const toggleGuestbookHide = (username, entryId) =>
    api.post(`/api/minihome/${u(username)}/guestbook/${entryId}/toggle-hide/`);
export const deleteGuestbook = (username, entryId) =>
    api.delete(`/api/minihome/${u(username)}/guestbook/${entryId}/`);

/**
 * 방명록 항목에 답글을 달거나 수정/삭제합니다. (PATCH)
 * @param {string} username - 미니홈피 주인 유저네임
 * @param {number} entryId - 방명록 글 ID
 * @param {object} data - { reply: "답글 내용" } 또는 { reply: null } (삭제)
 */
export const updateGuestbookEntry = (username, entryId, data) => {
    // urls.py에 정의한 /reply/ 엔드포인트를 호출합니다.
    return api.patch(`/api/minihome/${u(username)}/guestbook/${entryId}/reply/`, data);
};


// --- 리액션(응원) ---
export const getReactionSummary = (username) =>
    api.get(`/api/minihome/${u(username)}/reactions/summary/`);
export const postReaction = (username, type) =>
    api.post(`/api/minihome/${u(username)}/react/`, { type }); // 'heart' | 'rope' | 'leaf'
export const deleteTodayReaction = (username) =>
    api.delete(`/api/minihome/${u(username)}/react/`);

/**
 * 내 해금 정보를 가져옵니다. (보유 목록, 전체 아이템 가격)
 */
export const getMyUnlocks = () => api.get('/api/minihome/my/unlocks/');

/**
 * 특정 키의 아이템을 해금(구매)합니다.
 * @param {string} key - 해금할 아이템의 키
 */
export const buyUnlock = (key) => api.post('/api/minihome/my/unlocks/', { key });